var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimelineDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 455 455",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-697.234,-272.452)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,31.7965,30.5246)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 892.464,
    cy: 468.954,
    r: 227.027,
    style: {
      fill: "rgb(74,0,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.910364,0,0,0.910364,111.793,72.5597)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 892.464,
    cy: 468.954,
    r: 227.027,
    style: {
      fill: "rgb(136,0,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.352941,0,0,0.352941,609.273,333.965)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 892.464,
    cy: 468.954,
    r: 227.027,
    style: {
      fill: "rgb(74,0,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.254533,0,0,0.254533,697.099,380.114)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 892.464,
    cy: 468.954,
    r: 227.027,
    style: {
      fill: "white"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineDot);
export default __webpack_public_path__ + "static/media/timelineDot.b4a37684f0f3e88b43512179a1ae1b80.svg";
export { ForwardRef as ReactComponent };